import { SOLAR_BUILDINGS_DEFAULT_LIMIT } from "@/config/constants";
import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import { EventCategory } from "@/types/ui";
import { FrameName } from "../config";
import { EventUpgradeIds } from "../config/upgrades";
import EventTileEntity from "../EventTileEntity";

class BountifulMarketplaceBuildingTileEntity extends EventTileEntity {
	public static readonly eventType = EventCategory.SOLAR;

	public static readonly frameName = FrameName.BOUNTIFUL_MARKETPLACE;

	public buildingLimit =
		SOLAR_BUILDINGS_DEFAULT_LIMIT +
		getUpgradeCurrentReplaceValueById(
			EventUpgradeIds.sf_free_market_economy,
		) +
		getUpgradeCurrentReplaceValueById(EventUpgradeIds.sf_booming_economy) +
		getUpgradeCurrentReplaceValueById(EventUpgradeIds.sf_special_02);
}

export default BountifulMarketplaceBuildingTileEntity;
